/**
 *
 */
export function scrollToPoint(y, time) {
  setTimeout(() => {
    window.scrollTo(0, y - 70);
  }, time);
}
